import RemoteErrorsInterceptor, { withErrors } from "ra-remote-validator";
import React from "react";
import {
	AutocompleteInput,
	DateInput,
	Edit as RaEdit,
	ReferenceInput,
	required,
	SaveButton,
	SimpleForm,
	Toolbar as RaToolbar,
	useNotify,
	useRedirect,
	useRefresh,
} from "react-admin";
import { compose } from "recompose";
import { bookmakersConfig } from "../bookmakers";
import { useFormStyles } from "../components/forms/useStyles";

const Toolbar = (props) => (
	<RaToolbar {...props}>
		<SaveButton />
	</RaToolbar>
);

const Edit = ({ dispatch, validate, errors, staticContext, ...props }) => {
	const classes = useFormStyles();
	const notify = useNotify();
	const refresh = useRefresh();
	const redirect = useRedirect();
	return (
		<RaEdit
			id="reset"
			resource="stats"
			basePath="stats"
			redirect=""
			mutationMode="pessimistic"
			{...props}
			classes={classes}
			onSuccess={(data) => {
				redirect("/stats");
				notify("resources.stats.actions.reset.success");
				refresh();
			}}
		>
			<SimpleForm validate={validate} toolbar={<Toolbar />}>
				<RemoteErrorsInterceptor errors={errors} dispatch={dispatch} />
				<ReferenceInput
					source="bookmaker_id"
					reference="bookmakers"
					validate={required()}
					{...bookmakersConfig.reference}
				>
					<AutocompleteInput optionText="name" />
				</ReferenceInput>
				<DateInput source="start_at" validate={required()} />
				<DateInput source="end_at" validate={required()} />
				{/* <ReferenceArrayInput
					source="events"
					reference="events"
					format={formatMany}
					parse={parseMany}
					sort={{ field: "order", order: "ASC" }}
					validate={required()}
					fullWidth
					filter={{ user: true }}
				>
					<SelectArrayInput
						optionText={(choice) =>
							translate(`resources.stats.fields.${choice.name}`)
						}
					/>
				</ReferenceArrayInput> */}
			</SimpleForm>
		</RaEdit>
	);
};

export default compose(withErrors)(Edit);
